import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import trimStart from "lodash/trimStart";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentDomain } from '@/shared/util';
import { useRoute } from 'vue-router/composables';
export default /*#__PURE__*/ _defineComponent({
    __name: 'error',
    setup: function(__props) {
        var route = useRoute();
        var onRefresh = function() {
            var target = route.query.target;
            if (target == null) {
                return;
            }
            var domain = getCurrentDomain();
            window.location.replace("".concat(domain).concat(trimStart(decodeURIComponent(target), '/')));
        };
        return {
            __sfc: true,
            route: route,
            onRefresh: onRefresh
        };
    }
});
